import React from 'react'
import { Helmet } from 'react-helmet'
import Menu from '../component/Menu'
import HeaderCasestudy from '../component/HeaderCasestudy'
import Casestudybody20 from '../component/Casestudybody20'
import FooterNew from '../component/FooterNew';
import thumbimg from '../images/case-study-client16.webp'

const CaseStudy20 = ({setBlank}) => {
  // Financial Due Diligence For A U.S.-Based Private Equity Firm
  const headings = " <h2 style='display:inline-block;'>Financial Due Diligence </h2><h4>For A U.S.Based Private Equity Firm</h4>";

  return (
    <>
    <Helmet>
      <title>Financial Due Diligence For A U.S.Based Private Equity Firm</title>
      <meta property="og:image" content={thumbimg} /> 
      <meta property="og:title" content="Financial Due Diligence For A U.S.Based Private Equity Firm" />
      <meta property="og:description" content="Financial Due Diligence For A U.S.Based Private Equity Firm"/>
    </Helmet>

    <Menu setBlank={setBlank} />
    <HeaderCasestudy headings={headings} class="header-casestudy20" />  
    <Casestudybody20 />
    <FooterNew setBlank={setBlank} />
</>

  )
}

export default CaseStudy20
